// FeatureLoader.tsx
import { useParams, Navigate } from 'react-router-dom';
import Kpis from '../features/kpis/Kpis'; // or lazy + Suspense
import Values from '../features/value/Value';
import Dcf from '../features/dcf/Dcf';
import Green from '../features/green/Green';
import Download from '../features/download/Download';

export default function FeatureLoader() {
	const { feature } = useParams<{ feature: string }>();
	
	// List of valid features to prevent loops
	const validFeatures = ['kpis', 'green', 'value', 'dcf', 'download'];
	
	// If feature is not valid, redirect to home
	if (!feature || !validFeatures.includes(feature)) {
		console.warn(`Invalid feature: ${feature}. Redirecting to home.`);
		return <Navigate to="/" replace />;
	}

	switch (feature) {
		case 'kpis':
			return <Kpis />;
		case 'value':
			return <Values />;
		case 'dcf':
			return <Dcf />;
		case 'green':
			return <Green />;
		case 'download':
			return <Download />;
		default:
			// This should never happen due to validation above, but keeping for safety
			return <Navigate to="/" replace />;
	}
}
